// extracted by mini-css-extract-plugin
export var boldText = "_5l-4";
export var checkboxContainer = "_5l-6";
export var closeIcon = "_5l-i";
export var container = "_5l-0";
export var drawer = "_5l-8";
export var drawerContent = "_5l-9";
export var extraSmallText = "_5l-5";
export var fulfillmentGroupTable = "_5l-e";
export var largeText = "_5l-3";
export var loadingSpinnerContainer = "_5l-j";
export var mediumText = "_5l-2";
export var narrow = "_5l-f";
export var notificationLink = "_5l-l";
export var packageCheckIconContainer = "_5l-7";
export var slideoutHeaderActions = "_5l-g";
export var slideoutHeaderActionsShifted = "_5l-h";
export var slideoutHeaderContainer = "_5l-a";
export var slideoutModal = "_5l-c";
export var stickyHeaderWrapper = "_5l-b";
export var table = "_5l-k";
export var tableContainer = "_5l-d";
export var tertiaryText = "_5l-1";